import { useEffect, useState } from "react";
import styled from "styled-components";

const ToggleButton = ({ handleClickToggle, setValue, disabled = false }) => {
  const [active, setActive] = useState(setValue);

  useEffect(() => {
    setActive(setValue)
  }, [setValue]);

  return (
    <ToggleContainer
      $disabled={disabled}
      onClick={() => {
        if (!disabled) {
          handleClickToggle();
        }
      }}
    >
      <div className={`container ${active ? "cont-active" : ""}`}>
        <div className={`circle ${active ? "circle-active" : ""}`} />
      </div>
    </ToggleContainer>
  );
};

const ToggleContainer = styled.div`
  width: 42px;
  height: 22px;
  cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
  .container {
    width: 42px;
    height: 22px;
    border-radius: 45px;
    background-color: #b0b0b0;
    cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
    transition: 0.5s;
  }
  .cont-active {
    background-color: #1167ed;
    transition: 0.5s;
  }
  .circle {
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #ffffff;
    margin-left: 2px;
    margin-top: 2px;
    transition: 0.5s;
  }
  .circle-active {
    margin-left: 22px;
    transition: 0.5s;
  }
`;

export default ToggleButton;
